module.exports = __webpack_public_path__ + "static/media/shallow-seas.519c9d67.jpg";